import React, { useEffect, useRef, useState } from 'react';

function measureStickTop() {
  const navbar = document.querySelector('.navbar-header');
  const navBottom = navbar ? Math.ceil(navbar.getBoundingClientRect().bottom) : 76;
  const pin = document.querySelector('.klub-dashboard__pin');
  if (!pin) {
    return navBottom;
  }
  return navBottom + Math.ceil(pin.getBoundingClientRect().height);
}

const KslFrame = ({ columns, minWidth, header, children }) => {
  const headRef = useRef(null);
  const scrollRef = useRef(null);
  const [top, setTop] = useState(76);

  const syncScroll = () => {
    const head = headRef.current;
    const body = scrollRef.current;
    if (!head || !body) return;
    const headTable = head.firstElementChild;
    if (headTable) {
      headTable.style.width = `${body.scrollWidth}px`;
    }
    head.scrollLeft = body.scrollLeft;
  };

  useEffect(() => {
    const measure = () => {
      setTop(measureStickTop());
      syncScroll();
    };
    measure();
    const pin = document.querySelector('.klub-dashboard__pin');
    const navbar = document.querySelector('.navbar-header');
    const body = scrollRef.current;
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    if (pin) observer?.observe(pin);
    if (navbar) observer?.observe(navbar);
    if (body) observer?.observe(body);
    window.addEventListener('resize', measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  const min = typeof minWidth === 'number' ? `${minWidth}px` : minWidth;

  return (
    <div
      className="ksl"
      style={{
        '--ksl-cols': columns,
        '--ksl-min': min,
        '--ksl-stick-top': `${top}px`,
      }}
    >
      <div className="ksl__headstick" ref={headRef}>
        <div className="ksl__table">{header}</div>
      </div>
      <div className="ksl__scroll" ref={scrollRef} onScroll={syncScroll}>
        <div className="ksl__table">{children}</div>
      </div>
    </div>
  );
};

export default KslFrame;
